import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ProjectTeamGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isNpcProject = route.params.projectNrn?.includes('nrn:npc:project');

    if (isNpcProject) {
      this.router.navigate(['/projects']);
      return false;
    }
    return true;
  }
}
